export default "__VITE_ASSET__7df9d1a8__"